/**
 * Phase 28 / 41 — the "today's drops" metrics as the Flow Optimizer's metric
 * catalog, so the FO rule card's own field picker lists them, under three
 * headings: "Tracker (Voluum / Binom)" — the drop's own tracker row, the SAME
 * names and formulas as the list's / gateway's stats (CR = conversions per
 * 100 visits, CV = per 100 clicks) — then "SMSWiser" and "Tracker + SMSWiser".
 * A 0–1 rate is typed in percent — 85 is stored 0.85 (the aggregate's unit);
 * the SMSWiser and combined names carry their unit ("Delivered Rate (%)").
 * For Media Devoted | Created By Ciro Autiero
 */
import { type FlowOptimizerMetricMeta, GATE_METRIC_GROUP_LABELS, GATE_METRICS } from '@trafficpulse/shared';

type Category = FlowOptimizerMetricMeta['category'];

const CATEGORY: Record<(typeof GATE_METRICS)[number]['format'], Category> = {
  int: 'traffic',
  money: 'financial',
  percent: 'rates',
  ratio: 'rates',
};
const UNIT: Record<string, string> = { ratio: ' (%)', percent: ' (%)', money: ' ($)' };

export const GATE_METRIC_CATALOG: FlowOptimizerMetricMeta[] = GATE_METRICS.map((m) => ({
  id: m.id as FlowOptimizerMetricMeta['id'],
  name: m.group === 'tracker' ? m.label : `${m.label}${UNIT[m.format] ?? ''}`,
  category: CATEGORY[m.format],
  section: GATE_METRIC_GROUP_LABELS[m.group],
}));

const RATIO = new Set(GATE_METRICS.filter((m) => m.format === 'ratio').map((m) => m.id as string));

/** A 0–1 rate is shown and typed in percent: 0.85 ↔ 85 (rounded so 0.85 × 100 never reads 85.00000000000001). */
export const toInputValue = (metric: string, value: number): number => (RATIO.has(metric) ? Math.round(value * 100 * 1e6) / 1e6 : value);
export const fromInputValue = (metric: string, value: number): number => (RATIO.has(metric) ? Math.round((value / 100) * 1e9) / 1e9 : value);
